import {Component, EventEmitter, Input, Output} from "@angular/core";
@Component({
	selector: "activate-ccd-overview-step",
	template: `
		<modal (close)="onModalClosed()"
			   modalClasses="modal-wide"
			   [clickToClose]="false">
			<header class="modal_header">
				<h2 class="text-center">
					Activate Services Trial
				</h2>
			</header>
			<div class="modal_body px-4 py-3">
				<div>
					<p class="mb-3">
						This activation wizard will walk you through the following steps to activate your connected-cockpit device:
					</p>
					<div class="ccd-overview-list-row" *ngFor="let step of getSteps()"><div class="ccd-overview-circle-character">{{ step[0] }}</div>{{ step[1] }}</div>
					<p class="mt-3">
						Note: Trials may not be available for all aircraft and devices.
					</p>
				</div>
			</div>
			<footer class="modal_footer">
				<div>
					<button
							(click)="onModalClosed()"
							class="button button-secondary py-1 px-5">
						CANCEL
					</button>
					<button
							(click)="onContinue()"
							class="button button-primary py-1 px-5 modal_buttons">
						CONTINUE
					</button>
				</div>
			</footer>
		</modal>
	`,
})
export class ActivateCCDOverviewStepComponent {
	@Input() isOEM: boolean;
	@Input() isLteWifiDevice: boolean;
	@Input() isTelephonyDevice: boolean;
	@Output() continueSelected = new EventEmitter();
	@Output() modalClosed = new EventEmitter();
	telephonyConnectedCockpitDeviceIds: Array<number>;
	connextLteWifiEligibleConnectedCockpitDeviceIds: Array<number>;

	/* event emitters */
	onContinue() {
		this.continueSelected.emit();
	}

	onModalClosed() {
		this.modalClosed.emit();
	}

	getSteps(): Array<[number, string]> {
		let currentStep: number = 1;
		let steps: Array<[number, string]> = [];
		steps.push([currentStep++, 'Select or create a billing account for connected services']);
		steps.push([currentStep++, 'Accept terms and conditions']);
		if (this.isTelephonyDevice) {
			steps.push([currentStep++, 'Activate a Satellite service trial (if applicable)']);
		}
		if (this.isLteWifiDevice) {
			steps.push([currentStep++, 'Activate an LTE/Wi-Fi service trial (if applicable)']);
			steps.push([currentStep++, 'Activate an aviation database trial (if applicable)']);
		}

		return steps;
	}
}
